import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TrackingModule} from '@ox/utils';
import {GhostImageModule} from '../ghost-image';
import {TranslateModule} from '@ox/translate';
import {VehiclePickerComponent} from './vehicle-picker.component';
import {ModalModule} from 'ngx-bootstrap/modal';

@NgModule({
  declarations: [
    VehiclePickerComponent
  ],
  imports: [
    CommonModule,
    TrackingModule,
    TranslateModule,
    GhostImageModule,
    ModalModule.forRoot()
  ],
  exports:[
    VehiclePickerComponent
  ]
})
export class VehiclePickerModule { }
